<template>
  <div class="dialog-wrap">
    <el-dialog title="查看详情"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="close"
               @open="handleOpen"
               width="880px">
      <div class="main-wrap"
           v-if="content !=null">
        <el-descriptions direction="horizontal"
                         :column="1"
                         border
                         :labelStyle="mylabel"
                         title=""
                         style="width:400px">
          <template slot="extra">
          </template>
          <el-descriptions-item label="类别">{{
            content.question_type==1 ? '问题反馈':'功能建议'
          }}</el-descriptions-item>

          <el-descriptions-item label="内容描述">{{
            content.question_content
          }}</el-descriptions-item>
          <el-descriptions-item label="关联图片">
            <div v-if="content.question_img_urls.length >0"
                 style="display:flex;flex-flow: wrap;">
              <div v-for="(item,index) in content.question_img_urls"
                   :key="index"> <el-image style="width: 35px; height: 35px"
                          fit="cover"
                          :src="item"
                          :preview-src-list="[item]">
                </el-image></div>
            </div>

          </el-descriptions-item>
          <el-descriptions-item label="联系方式">{{
            content.creator_obj.mobile
          }}</el-descriptions-item>

          <el-descriptions-item label="处理进度">
            <el-tag v-if="content.handle_progress_status==0"
                    type="warning">待处理</el-tag>
            <el-tag v-if="content.handle_progress_status==1">已查看</el-tag>
            <el-tag v-if="content.handle_progress_status==2">已处理</el-tag>
            <el-tag v-if="content.handle_progress_status==3"
                    type="info">已采纳</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="提交人">{{
            content.creator_obj.creator_obj
          }}</el-descriptions-item>
          <el-descriptions-item label="提交时间">{{
          content.create_time
          }}</el-descriptions-item>

        </el-descriptions>

        <div class="progess">
          <el-form class="search-wrap"
                   ref="form"
                   :inline="true"
                   :model="form"
                   size="small"
                   :rules="rules"
                   label-position="left">
            <el-form-item label="处理进度"
                          prop="handle_progress_status"
                          label-width="80px">
              <el-select v-model="form.handle_progress_status"
                         placeholder="请选择"
                         clearable
                         style="width:300px;">
                <el-option v-for="item in  progressStatus"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="回复内容（选填）"
                          prop="reply_content"
                          label-width="80px">
              <el-input v-model="form.reply_content"
                        type="textarea"
                        rows="6"
                        placeholder="请输入回复内容"
                        style="width:300px;"></el-input>
            </el-form-item>
          </el-form>

        </div>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { feedbackDetail, feedbackPut } from '@/api/senior'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: () => {
        return null
      },
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      mylabel: {
        width: '120px',
      },
      rules: {
        handle_progress_status: [
          { required: true, message: '请选择处理进度', trigger: 'change' },
        ],
      },
      content: null,
      form: { handle_progress_status: null, reply_content: '' },
      progressStatus: [
        {
          label: '待处理',
          value: 0,
        },
        {
          label: '已查看',
          value: 1,
        },
        {
          label: '已处理',
          value: 2,
        },
        {
          label: '已采纳',
          value: 3,
        },
      ],
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  methods: {
    close() {
      this.form = { handle_progress_status: null, reply_content: '' }
      this.$emit('close')
    },

    handleOpen() {
      feedbackDetail({
        id: this.id,
      }).then((res) => {
        this.content = res
        if (this.content.question_img_urls != '') {
          this.content.question_img_urls =
            this.content.question_img_urls.split(',')
        }
        this.form.reply_content = this.content.reply_content
        this.form.handle_progress_status = this.content.handle_progress_status
        console.log('res', res)
      })
    },
    submit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let data = {
            id: this.content.id,
            handle_progress_status: this.form.handle_progress_status,
            reply_content: this.form.reply_content,
          }
          feedbackPut(data).then((res) => {
            this.$message.success(`操作成功`)
            this.$refs['form'].resetFields()
            this.close()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .el-dialog__header {
  background: #ebeef5;
}
.dialog-wrap {
  .main-wrap {
    display: flex;
    justify-content: space-between;
    .imgBox {
      display: flex;
      flex-flow: wrap;
      .questionImg {
        margin-right: 4px;
        width: 35px;
        height: 35px;
      }
    }
    .progess {
      width: 400px;
      margin-left: 40px;
    }
  }
  .form-wrap {
    width: 50%;
  }
  .el-form-item-wrap {
    display: flex;

    /deep/ .el-form-item {
      flex: 1;
      margin-bottom: 10px;
    }
  }
  .footer-wrap {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
}
</style>
